"use client";

import React from "react";
import { Github } from "lucide-react";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation("translation");
  return (
    <footer className="border-t border-[--color-secondary] bg-[--color-background] text-[--color-text] py-6 px-4">
      <div
        className="max-w-7xl mx-auto flex flex-wrap justify-between items-center gap-4
                  sm:flex-row
                  flex-col
                  sm:justify-between
                  justify-center
                  sm:items-center
                  items-center
  "
      >
        <p className="text-sm text-center sm:text-left w-full sm:w-auto">
          © {new Date().getFullYear()} {t("footer")}.
        </p>
        <nav
          aria-label="Footer navigation"
          className="flex gap-6 justify-center w-full sm:w-auto"
        >
          {/* links */}
          <a
            href="https://github.com/BA-S12"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-[--color-subtext] hover:text-[--color-main] transition-colors focus:outline-none focus:ring-2 focus:ring-[--color-main] rounded"
          >
            GitHub <Github className="w-5 h-5" />
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
